import { render, staticRenderFns } from "./QuizIndexOld.vue?vue&type=template&id=7ca51648&"
import script from "./QuizIndexOld.vue?vue&type=script&lang=js&"
export * from "./QuizIndexOld.vue?vue&type=script&lang=js&"
import style0 from "./QuizIndexOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports